import * as React from "react";
import reduce from "lodash/reduce";
import styled, { css } from "styled-components";
import { useMemo } from "react";
import { Input } from "components/bootstrap";
import { Spinner } from "components/common";
import { formatTrafficData } from "util/TrafficUtils";
import useSendTelemetry from "logic/telemetry/useSendTelemetry";
import { TELEMETRY_EVENT_TYPE } from "logic/telemetry/Constants";
import { TrafficGraph, useGraphWidth } from "components/common/Graph";
import { getPathnameWithoutId } from "util/URLUtils";
import useLocation from "routing/useLocation";
import { DAYS } from "components/common/Graph/types";
import useGraphDays from "components/common/Graph/contexts/useGraphDays";
import { getPrettifiedValue } from "views/components/visualizations/utils/unitConverters";
import formatValueWithUnitLabel from "views/components/visualizations/utils/formatValueWithUnitLabel";
const StyledH3 = styled.h3(
  ({ theme }) => css`
    margin-bottom: ${theme.spacings.sm};
  `
);
const Wrapper = styled.div(
  ({ theme }) => css`
    margin-bottom: ${theme.spacings.xs};

    .control-label {
      padding-top: 0;
    }

    .graph-days-select {
      display: flex;
      align-items: baseline;

      select {
        padding-top: ${theme.spacings.xxs};
      }
    }
  `
);
const TrafficGraphWithDaySelect = ({ traffic, trafficLimit = void 0, title = void 0 }) => {
  const { graphDays, setGraphDays } = useGraphDays();
  const { graphWidth, graphContainerRef } = useGraphWidth();
  const { pathname } = useLocation();
  const sendTelemetry = useSendTelemetry();
  const onGraphDaysChange = (event) => {
    event.preventDefault();
    const newDays = Number(event.target.value);
    setGraphDays(newDays);
    sendTelemetry(TELEMETRY_EVENT_TYPE.TRAFFIC_GRAPH_DAYS_CHANGED, {
      app_pathname: getPathnameWithoutId(pathname),
      app_section: "outgoing-traffic",
      app_action_value: "trafficgraph-days-button",
      event_details: { value: newDays }
    });
  };
  const bytesOut = useMemo(() => traffic ? reduce(traffic, (result, value) => result + value) : null, [traffic]);
  const unixTraffic = useMemo(() => traffic ? formatTrafficData(traffic) : null, [traffic]);
  const formattedTotalTraffic = useMemo(() => {
    const prettified = getPrettifiedValue(bytesOut, { abbrev: "b", unitType: "binary_size" });
    return formatValueWithUnitLabel(prettified == null ? void 0 : prettified.value, prettified.unit.abbrev);
  }, [bytesOut]);
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(Wrapper, { className: "form-inline graph-days pull-right" }, /* @__PURE__ */ React.createElement(
    Input,
    {
      id: "graph-days",
      type: "select",
      bsSize: "small",
      label: "Days",
      value: graphDays,
      onChange: onGraphDaysChange,
      formGroupClassName: "graph-days-select"
    },
    DAYS.map((size) => /* @__PURE__ */ React.createElement("option", { key: `option-${size}`, value: size }, size))
  )), /* @__PURE__ */ React.createElement(StyledH3, { ref: graphContainerRef }, title != null ? title : "Outgoing traffic", " ", bytesOut && /* @__PURE__ */ React.createElement("small", null, "Last ", graphDays, " days: ", formattedTotalTraffic)), unixTraffic ? /* @__PURE__ */ React.createElement(TrafficGraph, { trafficLimit, traffic: unixTraffic, width: graphWidth }) : /* @__PURE__ */ React.createElement(Spinner, null));
};
export default TrafficGraphWithDaySelect;
